import axios from 'axios';

export default {
    async list() {
        let response = await axios.get('/api/siteNotifications');
        return response.data;
    },
    async listActive() {
        let response = await axios.get('/api/siteNotifications/active');
        return response.data;
    },
    async create(notification) {
        let response = await axios.post('/api/siteNotifications', notification);
        return response.data
    },
    async update(notification) {
        let response = await axios.patch(`/api/siteNotifications/${notification.id}`, notification);
        return response.data
    },
    async deleteNotification(notification) {
        let response = await axios.delete(`/api/siteNotifications/${notification.id}`);
        return response.data
    },
}
